module.exports = __webpack_public_path__ + "static/media/gallery7.1a4f76c9.png";